/*
 * node-cache 3.2.1 ( 2016-03-21 )
 * https://github.com/tcs-de/nodecache
 *
 * Released under the MIT license
 * https://github.com/tcs-de/nodecache/blob/master/LICENSE
 * 
 * Maintained by M. Peter ( https://github.com/mpneuried )
*/
(function() {
  var exports;

  exports = module.exports = require('./lib/node_cache');

  exports.version = '3.2.1';

}).call(this);
